<template>
  <div
    ref="component"
    class="tva-line-chart-component"
    :style="{
      width: config.globalFixedWidth ? config.globalFixedWidth + 'px' : '100%',
      height: config.globalFixedHeight
        ? config.globalFixedHeight + 'px'
        : '100%',
    }"
  >
    <svg>
      <Grid :p="params" :c="config" :d="data" />
      <g
        class="group"
        v-for="(serie, serieIndex) in reversedSeries"
        :id="'line-' + serieIndex"
        :key="serie.key"
        @mouseover="setHoveredStacked(serie.key)"
        @mouseout="setHoveredStacked(null)"
      >
        <LinePath
          :p="params"
          :c="config"
          :d="stackedData"
          :serie="serie"
          :previousSerie="reversedSeries[serieIndex + 1]"
        />
        <AreaPath
          :p="params"
          :c="config"
          :d="stackedData"
          :serie="serie"
          :previousSerie="reversedSeries[serieIndex + 1]"
        />
        <Dots
          :p="params"
          :c="config"
          :d="stackedData"
          :serie="serie"
          :previousSerie="reversedSeries[serieIndex + 1]"
          :serieIndex="serieIndex"
        />
      </g>
      <XAxis :p="params" :c="config" :d="stackedData" />
      <YAxis :p="params" :c="config" />
      <g
        class="group-tooltip"
        v-for="(serie, serieIndex) in reversedSeries"
        :key="'tooltip-' + serie.key"
      >
        <TooltipStackedArea
          :p="params"
          :c="config"
          :d="stackedData"
          :serie="serie"
          :previousSerie="reversedSeries[serieIndex + 1]"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import global from "@/charts/mixins/global";
import grid from "@/charts/mixins/grid";
import Grid from "@/charts/components/Grid";
import LinePath from "@/charts/components/LinePath";
import AreaPath from "@/charts/components/AreaPath";
import Dots from "@/charts/components/Dots";
import XAxis from "@/charts/components/XAxis";
import YAxis from "@/charts/components/YAxis";
import TooltipStackedArea from "./components/TooltipStackedArea.vue";
import { mapActions } from "vuex";

export default {
  props: ["data", "config"],
  mixins: [global, grid],
  created() {
    this.stacked = true;
  },
  computed: {
    params() {
      return {
        width: this.width,
        height: this.height,
        left: this.left,
        right: this.right,
        minX: this.maxMinX.min,
        maxX: this.maxMinX.max,
        minY: this.maxMinY[0].min,
        maxY: this.maxMinY[0].max,
        ticksX: this.ticksX,
        ticksY: this.ticksY,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        format: this.format,
        tooltipMove: this.tooltipMove,
      };
    },
    reversedSeries() {
      let series = this.config.series;
      return [...series].reverse();
    },
  },
  methods: {
    ...mapActions({
      setHoveredStacked: "ui/setHoveredStacked",
    }),
  },

  components: {
    Grid,
    LinePath,
    AreaPath,
    Dots,
    XAxis,
    YAxis,
    TooltipStackedArea,
  },
};
</script>

<style lang="scss" scoped>
.group {
}

.tva-line-chart-component {
  width: 100%;
  height: 100%;
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
